import { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import HomeIcon from "@mui/icons-material/Home";

// マニュアルページのデータ
const pages = [
  {
    main: {
      title: "はじめに",
      color: "primary",
      content: {
        text: "検査データ閲覧システムへようこそ！",
        subtext: "このシステムは、あなたの検査データを閲覧することができます。",
        image: "/images/ハシビロ先生背景なし.png",
        imageAlt: "ハシビロ先生",
      },
    },
    description: {
      title: "システムの目的",
      content: "過去の検査結果を確認でき、ご自身の健康維持をサポートします。",
    },
  },

  {
    main: {
      title: "サインアップ画面",
      color: "info",
      content: {
        image: "/images/検診_サインアップ画面.png",
        imageAlt: "サインアップ画面",
      },
    },
    description: {
      title: "サインアップ",
      content:
        "初回はサインアップ(登録)が必要です。必要事項を入力して登録ボタンを押すと確認メールが送信されます。",
    },
  },
  {
    main: {
      title: "メールを受診",
      color: "info",
      content: {
        image: "/images/検診_メール画面.png",
        imageAlt: "メール画面",
      },
    },
    description: {
      title: "サイドメニュー",
      content:
        "登録したメールアドレスに確認コードが添付されたメールが送信されます。",
    },
  },
  {
    main: {
      title: "確認コード入力画面",
      color: "success",
      content: {
        image: "/images/検診_確認コード入力画面.png",
        imageAlt: "入力画面 ",
      },
    },
    description: {
      title: "確認コード入力",
      content:
        "確認コードを入力して確定を押します。成功時アカウント登録完了となります。次回からはログイン画面からログインください。",
    },
  },
  {
    main: {
      title: "ログイン画面",
      color: "info",
      content: {
        image: "/images/検診_ログイン画面.png",
        imageAlt: "ログイン画面",
      },
    },
    description: {
      title: "ログイン",
      content: "ログインIDとご自身で決めたパスワードを入力してログインします。",
    },
  },
  {
    main: {
      title: "サイドメニュー",
      color: "info",
      content: {
        image: "/images/検診_サイドメニュー.png",
        imageAlt: "サイドメニュー",
      },
    },
    description: {
      title: "サイドメニュー",
      content:
        "画面左上のメニューボタンを押すとサイドメニューが表示されます。各種データの閲覧などができます。",
    },
  },
  {
    main: {
      title: "最新データ画面",
      color: "info",
      content: {
        image: "/images/検診_最新データ画面.png",
        imageAlt: "最新データ画面",
      },
    },
    description: {
      title: "最新データ",
      content: "最新の検査結果を確認できます。",
    },
  },
  {
    main: {
      title: "グラフ画面",
      color: "info",
      content: {
        image: "/images/検診_グラフ画面.png",
        imageAlt: "グラフ画面",
      },
    },
    description: {
      title: "検査グラフ",
      content:
        "検査結果をグラフで確認できます。受けた項目ごとにページが存在します。",
    },
  },
  {
    main: {
      title: "時系列データ画面",
      color: "info",
      content: {
        image: "/images/検診_時系列データ画面.png",
        imageAlt: "時系列データ画面",
      },
    },
    description: {
      title: "時系列データ",
      content: "検査結果を時系列で表形式で確認できます。",
    },
  },
  {
    main: {
      title: "パスワード変更画面",
      color: "info",
      content: {
        image: "/images/検診_パスワード変更画面.png",
        imageAlt: "パスワード変更画面",
      },
    },
    description: {
      title: "パスワード変更",
      content: "パスワードを変更できます。",
    },
  },
  {
    main: {
      title: "パスワードリセット画面",
      color: "error",
      content: {
        image: "/images/検診_パスワードリセット画面.png",
        imageAlt: "パスワードリセット画面",
      },
    },
    description: {
      title: "パスワードリセット",
      content:
        "パスワードを忘れてしまった場合、パスワードをリセットできます。ログインIDを入力してコードを送信ボタンを押すと確認メールが送信されます。",
    },
  },
  {
    main: {
      title: "確認コード入力画面",
      color: "success",
      content: {
        image: "/images/検診_パスワードリセット確認コード入力画面.png",
        imageAlt: "パスワードリセット確認コード入力画面",
      },
    },
    description: {
      title: "確認コード入力",
      content:
        "確認コードと新しいパスワードを入力して確定を押します。成功時パスワード変更完了となります。次回からは新しいパスワードでログインできます。",
    },
  },
  {
    main: {
      title: "お問い合わせ画面",
      color: "info",
      content: {
        image: "/images/検診_お問い合わせ画面.png",
        imageAlt: "お問い合わせ画面",
      },
    },
    description: {
      title: "サポート",
      content: "ご不明な点がある場合はお問い合わせください。",
    },
  },
];

export const ManualPage = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const handleNext = () => {
    if (currentPage < pages.length - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleTop = () => {
    // マニュアル訪問フラグを設定
    sessionStorage.setItem("manual_visited", "true");

    navigate("/");
  };

  const currentPageData = pages[currentPage];

  return (
    <Box
      sx={{
        height: "100vh",
        bgcolor: "orange.100",
        display: "flex",
        flexDirection: "column",
        p: 1,
      }}
    >
      {/* メインボックスエリア (3/4) */}
      <Box sx={{ height: "75%", mt: 1 }}>
        <Card
          sx={{
            height: "100%",
            mx: { xs: 0.5, md: 1, lg: 1.5 },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            p: 1, // 外枠に対して内側にマージンを追加
          }}
        >
          <CardContent sx={{ textAlign: "center", p: 0 }}>
            <div>
              <Typography
                variant={isMobile ? "h5" : "h4"}
                component="h2"
                gutterBottom
                color={`${currentPageData.main.color}.main`}
                sx={{ fontWeight: "bold", mb: { xs: 1, md: 2 } }}
              >
                {currentPageData.main.title}
              </Typography>

              <Stack spacing={2} sx={{ mb: 3 }}>
                {currentPageData.main.content.text && (
                  <Typography variant={isMobile ? "h6" : "h5"}>
                    {currentPageData.main.content.text}
                  </Typography>
                )}

                {currentPageData.main.content.subtext && (
                  <Typography variant="body1" sx={{ flexGrow: 1 }}>
                    {currentPageData.main.content.subtext}
                  </Typography>
                )}

                {currentPageData.main.content.image && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: 2,
                      flexGrow: 1,
                    }}
                  >
                    <Box
                      component="img"
                      src={currentPageData.main.content.image}
                      alt={currentPageData.main.content.imageAlt}
                      sx={{
                        width: "100%",
                        maxWidth: currentPage === 0 ? 160 : 400,
                        aspectRatio: "3/4", // 縦長画像の比率を保持
                        objectFit: "contain",
                        [theme.breakpoints.down("md")]: {
                          maxWidth: currentPage === 0 ? 136 : 300,
                        },
                      }}
                    />
                  </Box>
                )}
              </Stack>
            </div>
          </CardContent>
        </Card>
      </Box>

      {/* 下部エリア (1/4) */}
      <Box
        sx={{
          height: "25%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* ページインジケーター */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 1,
            mb: 1,
            mt: 1,
          }}
        >
          {pages.map((_, index) => (
            <Box
              key={index}
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                bgcolor: index === currentPage ? "primary.main" : "grey.300",
                cursor: "pointer",
              }}
              onClick={() => setCurrentPage(index)}
            />
          ))}
        </Box>

        {/* 説明ボックス */}
        <Card
          sx={{
            mx: { xs: 0.5, md: 1, lg: 1.5 },
            mb: 0.5,
            minHeight: 100,
            maxHeight: 100,
            overflowY: "auto",
          }}
        >
          <CardContent sx={{ p: 0.5 }}>
            <Typography
              variant="subtitle2"
              component="h3"
              color={`${currentPageData.main.color}.dark`}
              sx={{ fontWeight: "bold" }}
            >
              {currentPageData.description.title}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {currentPageData.description.content}
            </Typography>
          </CardContent>
        </Card>

        {/* ナビゲーションボタン */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            px: { xs: 1, md: 2, lg: 3 },
          }}
        >
          <Button
            variant="contained"
            startIcon={<NavigateBeforeIcon />}
            disabled={currentPage === 0}
            onClick={handlePrev}
            size="small"
            sx={{ opacity: currentPage === 0 ? 0.5 : 1 }}
          >
            前へ
          </Button>

          <Button
            variant="contained"
            color="success"
            startIcon={<HomeIcon />}
            onClick={handleTop}
            size="small"
          >
            トップへ戻る
          </Button>

          <Button
            variant="contained"
            endIcon={<NavigateNextIcon />}
            disabled={currentPage === pages.length - 1}
            onClick={handleNext}
            size="small"
            sx={{ opacity: currentPage === pages.length - 1 ? 0.5 : 1 }}
          >
            次へ
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
